module.exports = __webpack_public_path__ + "img/bd9882c.jpg";